import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeaves1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Leaves",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.9842 2.25134C18.284 2.23346 18.5648 2.39587 18.699 2.66424C19.0579 3.37927 20.262 6.58136 20.4232 10.4294C20.532 13.0093 19.8191 15.837 17.972 17.8541C17.076 18.8318 15.8118 19.7238 14.2308 20.0644C12.8118 20.3702 11.1956 20.2189 9.44561 19.3684L8.28692 21.3751C8.07989 21.7338 7.62091 21.8566 7.26202 21.6495C6.90411 21.4424 6.78106 20.9838 6.98809 20.6251L8.1463 18.6186C6.53399 17.528 5.59454 16.2037 5.1502 14.8215C4.65411 13.282 4.79522 11.7407 5.19415 10.4763C6.01788 7.86847 8.11017 5.83716 10.3978 4.64135C13.8118 2.85663 17.1858 2.29907 17.9842 2.25134ZM10.1976 18.0655C11.6326 18.7405 12.8773 18.8218 13.9149 18.5981C15.1258 18.3372 16.1302 17.6447 16.866 16.8409C18.3758 15.1918 19.0208 12.7908 18.9251 10.4921C18.7986 7.48303 17.9871 4.90539 17.5613 3.8106C16.4002 3.98932 13.7625 4.57507 11.0931 5.97064C9.05499 7.03607 7.29815 8.79547 6.62481 10.928C6.2962 11.9675 6.19806 13.183 6.57794 14.3621C6.90265 15.373 7.596 16.4103 8.89874 17.3157L13.6761 9.04083C13.8831 8.68213 14.3421 8.55926 14.7 8.76635C15.0589 8.97345 15.1819 9.43213 14.9749 9.79083L10.1976 18.0655Z",
		fill: "currentColor"
	})
});
export default SvgLeaves1Line;
